import React from 'react';
import { type } from 'ramda';
/* eslint-disable react-hooks/exhaustive-deps */
const useDidMount = (fn) => {
  React.useEffect(() => {
    if (type(fn) !== 'Function') {
      throw SyntaxError(`useDidMount expect a function, but got a ${type(fn)}`);
    }
    fn();
  }, []);
};

export default useDidMount;
